<template>
  <div :id="annotationId" :annotationId="annotationId">
    <v-row align="center" justify="space-between" no-gutters>
      <v-row no-gutters align="center">
        <!-- Message Owner -->
        <div :title="senderName" class="font700 mr-2 truncate-line mw-50">
          {{ senderName }}
        </div>
        <!-- Message Time -->
        <div class="font10" v-if="createdAt">
          {{ getFormatedDateAsPerTimeAndDate(createdAt) }}
        </div>
      </v-row>
      <!-- Message Version label -->
      <span
        v-if="isMessageReplyContent && !showMessageReply"
        class="font10 font700 primarygreen--text"
      >
        version {{ currentVersion }}
      </span>
    </v-row>
    <div v-if="noReplyContent" class="mt-2 mb-1">
      <span class="empty-reply-text font12 font300 ml-1">{{
        $message.DISPLAY_MESSAGE_FOR_EMPTY_REPLY_MESSAGE
      }}</span>
    </div>
    <div
      v-else-if="messageType === 'html'"
      :inner-html.prop="messageContent | sanitize"
      class="message-text"
      :class="isMessageReplyContent ? 'mt-2 mb-1' : 'mb-0 mt-2'"
    />
    <div
      v-else
      class="message-text"
      :class="isMessageReplyContent ? 'mt-2 mb-1' : 'mb-0 mt-2'"
    >
      {{ messageContent }}
    </div>
    <!-- Message attachments -->
    <message-attachments-list
      v-if="messageAttachments.length"
      :messageAttachments="messageAttachments"
    />
  </div>
</template>
<script>
const MessageAttachmentsList = () =>
  import('@/components/ArchiveSearch/ChatBox/MessageAttachmentsList');
import Regex from '@/constants/regex';
export default {
  name: 'message-common-content',

  components: { MessageAttachmentsList },

  props: {
    messageDetails: {
      type: Object,
      required: true
    },

    isMessageReplyContent: {
      type: Boolean,
      default: false
    },

    showMessageReply: {
      type: Boolean
    },

    currentVersion: {
      type: Number
    },
    messageGroupType: String
  },

  computed: {
    isExternalUser() {
      return this.messageDetails?.sender?.external;
    },
    senderName() {
      return this.messageDetails?.senderName || '';
    },
    createdAt() {
      return this.messageDetails.createdAt || '';
    },
    messageType() {
      return this.messageDetails?.message?.contentType || '';
    },
    messageContent() {
      let messageText;

      messageText = this.messageDetails?.message?.content || '';

      // Removing unncessary html content coming with attachments
      if (this.messageType !== 'html') {
        return messageText.replaceAll(
          Regex.attachmentTextContentInsideMessage,
          ''
        );
      }

      return messageText.replaceAll('<at ', '<at class="at"');
    },
    messageAttachments() {
      return this.messageDetails?.attachments || [];
    },
    noReplyContent() {
      const divElement = document.createElement('div');
      divElement.innerHTML = this.messageContent;

      const messageText = divElement.textContent.trim();
      return (
        this.messageAttachments?.[0]?.contentType === 'messageReference' &&
        !messageText
      );
    },
    annotationId() {
      const { messageId, id, hasReplies } = this.messageDetails || {};
      const isPreviewMessage =
        hasReplies && this.messageGroupType !== 'CHANNEL';
      const previewAnnotationId = `___${messageId || id || ''}_preview_message`;

      return isPreviewMessage
        ? previewAnnotationId
        : `___${id || messageId || ''}`;
    }
  }
};
</script>
<style lang="scss">
.message-text {
  word-break: break-word;
  overflow-x: auto;
  user-select: text;

  .at {
    color: #7440fb;
  }

  img {
    width: 100%;
  }

  a {
    color: #6888c9;
  }

  p {
    margin-bottom: 0;
  }
}
.empty-reply-text {
  font-style: italic;
  color: rgba(27, 35, 66, 0.6);
}
</style>
